<div class="pr-3 pl-4 h-full w-full flex flex-col overflow-auto" (window:resize)="onResize()">
  <div class="flex justify-between header-table" #pageOptionBtnGroup>
    <div class="title-page"><span class="title">Thống kê số lượng tỷ lệ tình trạng hôn nhân của người khuyết tật theo độ tuổi&nbsp;</span>
      <breadcrumbs [items]="breadcrumbs"></breadcrumbs>
    </div>
    <div class="btn-option flex">
      <ng-container *ngIf="btnType === buttonTypeEnum.ICON">
        <button nz-button class="flex items-center justify-center" nzTooltipTitle="Xuất excel"
          nzTooltipPlacement="bottom" nz-tooltip (click)="exportExcel()">
          <i nz-icon nzType="file-excel" nzTheme="twotone"></i>
        </button>
      </ng-container>
      <ng-container *ngIf="btnType === buttonTypeEnum.TEXT">0
        <button nz-button class="flex items-center justify-center" (click)="exportExcel()">
          Xuất excel
        </button>
      </ng-container>
      <ng-container *ngIf="btnType === buttonTypeEnum.TEXTANDICON">
        <button nz-button class="flex items-center justify-center" (click)="exportExcel()">
          <i nz-icon nzType="file-excel" nzTheme="twotone"></i>
          Xuất excel
        </button>
      </ng-container>
    </div>
  </div>
  <form nz-form class="ant-advanced-search-form" #pageSearch>
    <div nz-row [nzGutter]="24">
      <div nz-col nzSm="24" nzMd="12" nzLg="6" nzXl="6">
        <nz-form-item>
          <nz-form-label nzSpan="24">Năm</nz-form-label>
          <nz-form-control nzSpan="24" nzHasFeedback nzValidatingTip="Validating...">
            <nz-date-picker nzMode="year" [(ngModel)]="year" [ngModelOptions]="{standalone: true}"
              nzPlaceHolder="Nhập năm"></nz-date-picker>
          </nz-form-control>
        </nz-form-item>
      </div>
      <div nz-col nzSm="24" nzMd="12" nzLg="6" nzXl="6">
        <nz-form-item>
          <nz-form-label nzSpan="24">Tỉnh thành</nz-form-label>
          <asc-autocomplete [ascModel]="DisProvincesControl" (ascModelChange)="changeDisProvincesACFn($event)"
            placeholder="Chọn tỉnh thành..." [getListAC]="getDisProvincesACFn">
          </asc-autocomplete>
        </nz-form-item>
      </div>
      <div nz-col nzSm="24" nzMd="12" nzLg="6" nzXl="6">
        <nz-form-item>
          <nz-form-label nzSpan="24">Quận huyện</nz-form-label>
          <asc-autocomplete [ascModel]="DistrictControl" (ascModelChange)="changeDistrictACFn($event)"
            placeholder="Chọn quận huyện..." [getListAC]="getDistrictACFn">
          </asc-autocomplete>
        </nz-form-item>
      </div> 
      <div nz-col nzSm="24" nzMd="12" nzLg="6" nzXl="6">
        <nz-form-item>
          <nz-form-label nzSpan="24">Tình trạng hôn nhân</nz-form-label>
          <asc-autocomplete [ascModel]="MaritalStatusControl" (ascModelChange)="changeMaritalStatusACFn($event)"
            placeholder="Chọn tình trạng hôn nhân..." [getListAC]="getMaritalStatusACFn">
          </asc-autocomplete>
        </nz-form-item>
      </div> 
      <div nz-col nzSm="24" nzMd="12" nzLg="6" nzXl="6">
        <nz-form-item>
          <nz-form-label nzSpan="24">Mức độ KT</nz-form-label>
          <asc-autocomplete [ascModel]="LevelControl" (ascModelChange)="changeLevelACFn($event)"
            placeholder="Chọn mức độ KT..." [getListAC]="getLevelACFn">
          </asc-autocomplete>
        </nz-form-item>
      </div> 
      <div nz-col nzSm="24" nzMd="12" nzLg="6" nzXl="6">
        <nz-form-item>
          <nz-form-label nzSpan="24">Độ tuổi</nz-form-label>
          <nz-select [(ngModel)]="commonFilter.AgeId" [ngModelOptions]="{standalone: true}" nzAllowClear
            nzPlaceHolder="Chọn độ tuổi">
            <nz-option *ngFor="let type of listYearOld" [nzValue]="type.value" [nzLabel]="type.name"></nz-option>
          </nz-select>
        </nz-form-item>
      </div> 
      <div nz-col nzSm="24" nzMd="12" nzLg="6" nzXl="6">
        <nz-form-item>
          <nz-form-label nzSpan="24">Giới tính:</nz-form-label>
          <nz-form-control nzSpan="24">
            <nz-radio-group [(ngModel)]="commonFilter.Gender" [ngModelOptions]="{standalone: true}">
              <label nz-radio [nzValue]="1">Nam</label>
              <label nz-radio [nzValue]="0">Nữ</label>
            </nz-radio-group>
          </nz-form-control>
        </nz-form-item>
      </div> 
    </div>
    <div nz-row>
      <div nz-col [nzSpan]="24" class="search-area">
        <button nz-button class="flex items-center justify-center" [nzTooltipTitle]="isCollapse ? 'Mở rộng' : 'Đóng'"
          nz-tooltip (click)="toggleCollapse()">
          <i nz-icon nzType="filter" nzTheme="outline"></i>
        </button>
        <button nz-button class="flex items-center justify-center" (click)="clear()" nzTooltipTitle="Xóa tìm kiếm"
          nzTooltipPlacement="bottom" nz-tooltip>
          <i nz-icon nzType="clear" nzTheme="outline"></i>
        </button>
        <ng-container *ngIf="btnType === buttonTypeEnum.TEXT">
          <button nz-button class="flex items-center justify-center" [nzType]="'primary'" (click)="search()">
            Tìm kiếm
          </button>
        </ng-container>
        <ng-container *ngIf="btnType === buttonTypeEnum.ICON">
          <button nz-button class="flex items-center justify-center" style="width: 100px;" [nzType]="'primary'"
            nzTooltipTitle="Tìm kiếm" nzTooltipPlacement="bottom" nz-tooltip (click)="search()">
            <i nz-icon nzType="search" nzTheme="outline"></i>
          </button>
        </ng-container>
        <ng-container *ngIf="btnType === buttonTypeEnum.TEXTANDICON">
          <button nz-button class="flex items-center justify-center" [nzType]="'primary'" (click)="search()"><i nz-icon
              nzType="search" nzTheme="outline"></i>Tìm kiếm</button>
        </ng-container>
      </div>
    </div>
  </form>
  <div class="relative">
    <nz-table #Table [nzShowTotal]="rangeTemplate" nzBordered nzShowSizeChanger [nzData]="dataTable" nzSize="small"
      class="w-full absolute" [nzFrontPagination]="false" [nzTotal]="Total" [nzPageSize]="pageSize"
      [nzPageIndex]="pageIndex" [nzPageSizeOptions]="pageSizeOptions" [nzLoading]="loading"
      [nzScroll]="{y: height + 'px', x: width + 'px'}" (nzPageIndexChange)="pageIndexEvent($event)"
      (nzPageSizeChange)="pageSizeEvent($event)">
      <thead>
        <tr #pageHeaderTable>
          <th nzWidth="50px" rowspan="3" nzLeft>STT</th>
          <th rowspan="3" nzWidth="150px" nzLeft>Độ tuổi</th> 
          <th rowspan="3" nzWidth="150px" nzLeft>Mức độ khuyết tật</th> 
          <ng-container *ngFor="let item of header1Arr">
            <th class="text-center" 
              [colspan]="2">
              {{ item.Name }}
            </th>
          </ng-container> 
        </tr>
        
        <tr #pageHeaderTable3>
          <ng-container *ngFor="let item of header2Arr">
            <th class="text-center">
              {{item.ColName}}
            </th> 
          </ng-container>
        </tr>
   
      
      </thead>
      <tbody>
        <tr *ngFor="let data of Table.data; let i = index">
          <td nzLeft>{{ i + 1 + (pageIndex-1)*pageSize }}</td>
          <td nzLeft>{{data.CaseOldName}}</td>  
          <td nzLeft>{{data.LevelName}}</td>  
          <ng-container *ngFor="let key of header2Arr">
            <td class="text-center">{{data[key.PivotCode] ? data[key.PivotCode] : 0}}</td>
          </ng-container>  
        </tr>
      </tbody>
    </nz-table>
  </div>
</div>
<ng-keyboard-shortcuts [shortcuts]="shortcuts"></ng-keyboard-shortcuts>
<ng-template #rangeTemplate let-range="range" let-total> {{ range[0] }}-{{ range[1] }} của {{ Total }} </ng-template>
